import { render } from "./PrayActive.vue?vue&type=template&id=5c169fda"
import script from "./PrayActive.vue?vue&type=script&lang=js"
export * from "./PrayActive.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__